<template>
  <div class="broken" :class="{ 'full-height': broken }">
    <template v-if="!broken">
      <div id="app-word">
        <form id="office_form" name="office_form" target="office_frame" action="" method="post">
          <input name="access_token" id="access_token" value="" type="hidden" />
          <input name="access_token_ttl" id="access_token_ttl" value="" type="hidden" />
        </form>
        <span id="frameholder"></span>
        <login ref="logincall"></login>
      </div>
    </template>
    <template v-if="broken">
      <div class="broken-link">
        <div class="logo">
          <img src="@/assets/logo-small-white.png" />
        </div>
        <div class="broken-text">
          <svg style="width:100px;height:84px" viewBox="-2 2 28 18">
            <path fill="#ccc"
              d="M17,7H13V8.9H17C18.71,8.9 20.1,10.29 20.1,12C20.1,13.43 19.12,14.63 17.79,15L19.25,16.44C20.88,15.61 22,13.95 22,12A5,5 0 0,0 17,7M16,11H13.81L15.81,13H16V11M2,4.27L5.11,7.38C3.29,8.12 2,9.91 2,12A5,5 0 0,0 7,17H11V15.1H7C5.29,15.1 3.9,13.71 3.9,12C3.9,10.41 5.11,9.1 6.66,8.93L8.73,11H8V13H10.73L13,15.27V17H14.73L18.74,21L20,19.74L3.27,3L2,4.27Z" />
          </svg>
          <span class="link">
            Link is broken or does not exist
          </span>
        </div>
      </div>
    </template>
    <loading ref="loading"></loading>
  </div>
</template>
<style scoped>
.full-height {
  display: flex;
  justify-content: center;
  align-items: center;
}

.broken {
  height: 100%;
}

.broken-link {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.broken-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
}

body {
  margin: 0;
  padding: 0;
  overflow: hidden;
  -ms-content-zooming: none;
}

#app-word {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

#office_frame {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  border: none;
  display: block;
}

#frameholder {
  display: block;
  width: 100%;
  height: 100%;
}

iframe#office_frame {
  width: 100%;
  height: 100%;
  display: block;
}

.login_pop {
  top: 0;
}
</style>
<script>
import { getfileviewdocinfo } from '@/services/Api'
import loading from '../components/Loading'
import cookies from '@/services/cookies'

export default {
  components: {
    loading
  },
  data() {
    return {
      broken: false
    }
  },
  methods: {
    load(url) {
      document.querySelector('#access_token').value = 'None'// cookies.getCookie('token')

      document.querySelector('#access_token_ttl').value = Date.now() + 60 * 60 * 60 * 1000
      document.querySelector('#office_form').setAttribute('action', url)

      var frameholder = document.getElementById('frameholder')
      var office_frame = document.createElement('iframe')
      office_frame.name = 'office_frame'
      office_frame.id = 'office_frame'
      office_frame.style.width = '100%'
      office_frame.style.height = '100%'
      // The title should be set for accessibility
      office_frame.title = 'Office Frame'
      // This attribute allows true fullscreen mode in slideshow view
      // when using PowerPoint's 'view' action.
      office_frame.setAttribute('allowfullscreen', 'true')
      // The sandbox attribute is needed to allow automatic redirection to the O365 sign-in page in the business user flow
      office_frame.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation allow-popups-to-escape-sandbox')
      frameholder.appendChild(office_frame)
      document.getElementById('office_form').submit()
    }
  },
  mounted() {
    console.log('ueuur')
    let data = {
      link: location.href
    }

    let that = this

    getfileviewdocinfo(data).then(res => {
      console.log('yeyy')
      let link = document.querySelector("link[rel*='icon']")
      if (res.data.result === 'success') {
        link.type = 'image/x-icon'
        link.rel = 'shortcut icon'
        link.href = res.data.action.favIconUrl
        this.load(res.data.action.urlsrc)
      } else {
        link.type = 'image/x-icon'
        link.rel = 'shortcut icon'
        link.href = res.data.action.favIconUrl
        this.load(res.data.action.urlsrc)
      }
      // if (res.data.data === true) {
      //   let link = document.querySelector("link[rel*='icon']")
      //   if (res.data.result === 'success') {
      //     link.type = 'image/x-icon'
      //     link.rel = 'shortcut icon'
      //     link.href = res.data.action.favIconUrl
      //     this.load(res.data.action.urlsrc)
      //   } else {
      //     link.type = 'image/x-icon'
      //     link.rel = 'shortcut icon'
      //     link.href = res.data.action.favIconUrl
      //     this.load(res.data.action.urlsrc)
      //   }
      // } else {
      //   that.$refs.loading.close()
      //   that.broken = true
      //   that.$router.push('/login')
      // }
    }).catch(err => {
      that.$refs.loading.close()
      that.broken = true
    })
  }
}
</script>
